module.exports = __webpack_public_path__ + "static/media/wine-red.944575b6.svg";